// extracted by mini-css-extract-plugin
export default {"tags":"Interests_tags__U3RLH","interests":"Interests_interests__a48EA","link":"Interests_link__yR3wV"};